import { render, staticRenderFns } from "./layoutBlank.vue?vue&type=template&id=3ca987f7&"
import script from "./layoutBlank.vue?vue&type=script&lang=js&"
export * from "./layoutBlank.vue?vue&type=script&lang=js&"
import style0 from "./layoutBlank.vue?vue&type=style&index=0&lang=less&"
import style1 from "./layoutBlank.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports